import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, login, logout }}>
      <Outlet />
    </AuthCtx.Provider>
  );
};

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#240620] text-[#F3E5AB]"><Loader2 className="animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
